import { orderBy } from "@progress/kendo-data-query";
import { getter } from "@progress/kendo-react-common";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Tooltip } from "@progress/kendo-react-tooltip";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NotificationManager } from "src/util/notify";
import DeleteDialogModal from "../../control-components/custom-delete-dialog-box/delete-dialog";
import Loader from "../../control-components/loader/loader";
import NOTIFICATION_MESSAGE from "../../helper/notification-messages";
import { useNavigate } from "react-router";
import APP_ROUTES from "../../helper/app-routes";
import SearchModel from "./searchModel";
import { AnnouncementServices } from "../../services/announcementService";
import DatePickerKendoRct from "../../control-components/date-picker/date-picker";
import moment from "moment";
import { SELECTED_ANNOUNCEMENT_FILTER } from "../../actions";


const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);
function Announcement() {
  const navigate = useNavigate();
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [sort, setSort] = useState([]);
  const announcementFiter = useSelector((state) => state?.announcementFiter);
  const [selectedState, setSelectedState] = React.useState({});
  const [finalValue, setFinalValue] = useState();
  const [loading, setLoading] = useState(false);
  const [announcements, setAnnouncements] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [isDeleteConfirm, setDeleteConfirm] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchApiQuery, setsearchApiQuery] = useState([]);
  const [clearGrid, setClearGrid] = useState(false);
  const dispatch = useDispatch();

  const [fields, setFields] = useState({
    clinicId: null,
    roleId: null,
    stateId: null,
    dateStart: moment().subtract(3, "days").startOf("day").format("M/D/YYYY"),
    dateEnd: moment().endOf("day").format("M/D/YYYY"),
  });
  const [keyword, setKeyword] = useState('');
  const [title, setTitle] = useState('');



  useEffect(() => {
    if (announcementFiter) {

      setFields({
        dateStart: announcementFiter.dateStart,
        dateEnd: announcementFiter.dateEnd,
      });
      const data = {
        clinicId: null,
        roleId: null,
        stateId: null,
        title: null,
        dateStart: moment(announcementFiter.dateStart).format("M/D/YYYY"),
        dateEnd: moment(announcementFiter.dateEnd).format("M/D/YYYY"),
        keyword: null
      };
      AnnouncementServices.getAnnouncements(data)
        .then((result) => {
          setAnnouncements(result.resultData);
          setsearchApiQuery(result.resultData);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          NOTIFICATION_MESSAGE.error(error);
        });
    }
  }, []);

  const handleAddAnnouncement = () => {
    navigate(APP_ROUTES.ADD_ANNOUNCEMENT);
  };
  const getAnnouncements = async () => {
    setLoading(true);
    const data = {
      clinicId: fields.clinicId?.id,
      roleId: fields.roleId?.id,
      stateId: fields.stateId?.id,
      title: title,
      dateStart: moment(fields.dateStart).format("M/D/YYYY"),
      dateEnd: moment(fields.dateEnd).format("M/D/YYYY"),
      keyword: keyword,
    };
    await AnnouncementServices.getAnnouncements(data)
      .then((result) => {
        setAnnouncements(result.resultData);
        setsearchApiQuery(result.resultData);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        NOTIFICATION_MESSAGE.error(error);
      });
  };

  const pageChange = (event) => {
    let skip = event.page.skip;
    let take = event.page.take;
    setPage(skip);
    setPageSize(take);
    let newValue = skip / take;
    let finalValue = newValue + 1;
    setFinalValue(finalValue);
  };


  const deleteAnnouncement = async () => {
    setLoading(true);
    await AnnouncementServices.deleteAnnouncement(selectedId)
      .then((result) => {
        NotificationManager.success("Announcement Deleted");
        setLoading(false);
        setDeleteConfirm(!isDeleteConfirm);
        setClearGrid(true);
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error.message);
      });
  };
  const deleteSelectId = (id) => {
    setDeleteConfirm(true);
    setSelectedId(id);
  };
  const handleClose = () => {
    setDeleteConfirm(!isDeleteConfirm);
  };
  const handleFilter = (e) => {
    if (e.target.value === "") {
      setAnnouncements(searchApiQuery);
    } else {
      const filterResult = searchApiQuery.filter(
        (item) =>
          item.url.toLowerCase().includes(e.target.value.toLowerCase()) ||
          item.title
            .toString()
            .toLowerCase()
            .includes(e.target.value.toString().toLowerCase()) ||
          item.trainingDate
            .toString()
            .toLowerCase()
            .includes(e.target.value.toString().toLowerCase())
      );
      setAnnouncements(filterResult);
    }
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    if (clearGrid) {
      getAnnouncements();
      setClearGrid(false);
    }
  }, [clearGrid])

  const handleClearGrid = () => {
    setClearGrid(true);
    setFields((prevFields) => ({
      ...prevFields,
      clinicId: null,
      roleId: null,
      stateId: null,
      title: null,
      keyword: null,
      dateStart: moment().subtract(3, "days").startOf("day").format("M/D/YYYY"),
      dateEnd: moment().endOf("day").format("M/D/YYYY"),
    }))
    dispatch({
      type: SELECTED_ANNOUNCEMENT_FILTER,
      payload: null,
    });
    setPage(0);
    setPageSize(10);
    setFinalValue(1);
  }
  return (
    <>
      <h4 className="address-title text-grey ">
        <span className="f-24">Announcements</span>
      </h4>
      <div className="d-flex flex-wrap justify-content-between align-items-center">
        <div className="align-items-end">
          <SearchModel
            page={page}
            pageSize={pageSize}
            finalValue={finalValue}
            fetchFromParent={setAnnouncements}
            setFields={setFields}
            fields={fields}
            onClear={handleClearGrid}
            title={title}
            keyword={keyword}
            setTitle={setTitle}
            setKeyword={setKeyword}
          />
        </div>

      </div>
      <div className="d-flex justify-content-end">
        <button className="green-btn btn-primary" onClick={handleAddAnnouncement}>
          <span
            className="fa fa-plus"
            style={{ color: "#fff" }}
          ></span>{" "}
          Add Announcement
        </button>

      </div>
      <div className="grid-table  filter-grid">
        <div className=" mt-3">
          <div className="inner-section-edit position-relative text-center">
            <div className="grid-table  filter-grid header-blue">
              <div className=" mt-3">
                {loading === true ? <Loader /> :
                  <Grid
                    style={{ height: '500px' }}
                    data={orderBy(
                      announcements.slice(page, pageSize + page),
                      sort
                    ).map((item) => ({
                      ...item,
                      [SELECTED_FIELD]: selectedState[idGetter(item)],
                    }))}
                    skip={page}
                    take={pageSize}
                    total={announcements.length}
                    onPageChange={pageChange}
                    pageable={{
                      pageSizes: [10, 20, 30, 100, 500],
                    }}
                  >

                    <GridColumn
                      className="cursor-default"
                      field="title"
                      title="Title"
                    />
                    <GridColumn
                      className="cursor-default"
                      field="dateStart"
                      title="Start Date"
                      cells={{
                        data: (props) => {
                          let field = moment(props?.dataItem?.dateStart)
                            .local()
                            .format("M/D/YYYY");

                          return (
                            <td className="cursor-default">
                              {props.dataItem.dateStart &&
                                props.dataItem.dateStart != null
                                ? moment(props.dataItem.dateStart)
                                  .local()
                                  .format("M/D/YYYY")
                                : "-"}
                            </td>
                          );
                        }
                      }}
                    />
                    <GridColumn
                      className="cursor-default"
                      field="dateEnd"
                      title="Expiration Date"
                      cells={{
                        data: (props) => {
                          let field = moment(props?.dataItem?.dateEnd)
                            .local()
                            .format("M/D/YYYY");
                          return (
                            <td className="cursor-default">
                              {props.dataItem.dateEnd &&
                                props.dataItem.dateEnd != null
                                ? moment(props.dataItem.dateEnd)
                                  .local()
                                  .format("M/D/YYYY")
                                : "-"}
                            </td>
                          );
                        }
                      }}
                    />
                    <GridColumn
                      className="cursor-default"
                      field="isForEveryone"
                      title="Everyone"
                      cells={{
                        data: (props) => {
                          let field = props.dataItem.isForEveryone;
                          return (
                            <td className="cursor-default">
                              {field === true ? (
                                <span
                                  className="fa fa-check-circle cursor-default  f-18"
                                  style={{ color: "green" }}
                                ></span>
                              ) : null}
                            </td>
                          );
                        }
                      }}
                    />
                    <GridColumn
                      className="cursor-default"
                      field="isClinicSpecific"
                      title="Clinic Specific"
                      cells={{
                        data: (props) => {
                          let field = props.dataItem.isClinicSpecific;
                          return (
                            <td className="cursor-default">
                              {field === true ? (
                                <span
                                  className="fa fa-check-circle cursor-default  f-18"
                                  style={{ color: "green" }}
                                ></span>
                              ) : null}
                            </td>
                          );
                        }
                      }}
                    />
                    <GridColumn
                      className="cursor-default"
                      field="isRoleSpecific"
                      title="Role Specific"
                      cells={{
                        data: (props) => {
                          let field = props.dataItem.isRoleSpecific;
                          return (
                            <td className="cursor-default">
                              {field === true ? (
                                <span
                                  className="fa fa-check-circle cursor-default  f-18"
                                  style={{ color: "green" }}
                                ></span>
                              ) : null}
                            </td>
                          );
                        }
                      }}
                    />
                    <GridColumn
                      className="cursor-default"
                      field="isStateSpecific"
                      title="State Specific"
                      cells={{
                        data: (props) => {
                          let field = props.dataItem.isStateSpecific;
                          return (
                            <td className="cursor-default">
                              {field === true ? (
                                <span
                                  className="fa fa-check-circle cursor-default  f-18"
                                  style={{ color: "green" }}
                                ></span>
                              ) : null}
                            </td>
                          );
                        }
                      }}
                    />
                    import moment from 'moment';

                    <GridColumn
                      className="cursor-default"
                      field="status"
                      title="Status"
                      cells={{
                        data: (props) => {
                          const currentDate = moment();
                          const startDate = props.dataItem.dateStart ? moment(props.dataItem.dateStart) : null;
                          const endDate = props.dataItem.dateEnd ? moment(props.dataItem.dateEnd) : null;

                          let status = '';

                          if (startDate && endDate) {
                            if (currentDate.isBetween(startDate, endDate, 'day', '[]')) {
                              status = "Active";
                            } else if (currentDate.isBefore(startDate)) {
                              status = "Scheduled";
                            } else if (currentDate.isAfter(endDate)) {
                              status = "Expired";
                            }
                          }

                          return (
                            <td className={`cursor-default ${status}`}>
                              {status}
                            </td>
                          );
                        }
                      }}
                    />
                    <GridColumn
                      width={150}
                      title="Action"
                      filterable={false}
                      cells={{
                        data: (props) => {
                          let field = props.dataItem;
                          return (
                            <td>
                              <div className="row-3">
                                <div
                                  className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-red"
                                  onClick={() => deleteSelectId(field.id)}
                                >
                                  <div className="k-chip-content">
                                    <Tooltip anchorElement="target" position="top">
                                      <i
                                        className="fa fa-trash"
                                        aria-hidden="true"
                                        title="Delete"
                                      ></i>
                                    </Tooltip>
                                  </div>
                                </div>
                                <div
                                  className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-green m-2"
                                  onClick={() =>
                                    navigate(APP_ROUTES.EDIT_ANNOUNCEMENT, {
                                      state: field,
                                    })
                                  }
                                >
                                  <div className="k-chip-content">
                                    <Tooltip anchorElement="target" position="top">
                                      <i className="fas fa-edit" title="Edit"></i>
                                    </Tooltip>
                                  </div>
                                </div>
                              </div>
                            </td>
                          );
                        }
                      }}
                    />
                  </Grid>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {isDeleteConfirm && (
        <DeleteDialogModal
          onClose={handleClose}
          title="Announcement"
          message="Announcement"
          handleDelete={deleteAnnouncement}
        />
      )}
    </>
  );
}
export default Announcement;